// extracted by mini-css-extract-plugin
module.exports = {"project":"project_project__3kHIC","back":"project_back__1gusr"};